import qweBaseField from "../BaseField";
import { getDepart } from "../../../apis/httpHelper"
import { ChoiceOptionsDefaultType } from "../../../common/constant";
import { listToTree } from "../../../common/commonHelper";

export default{
    mixins:[qweBaseField],
    data:function(){
        return {
            reComputedOptions:false,
            options:[],
            departList:[],
            showState:false
        }
    },
    filterOptionsFunc:{},
    scriptOptionsFunc:{},
    localOptions:[],
    created:function(){
        this.handleOptionsFuncScript();
        let self = this;
        let optionsRely = this.selfSetting.DepartOptions.RelyFields || [];
        this.getAllDepart(()=>{
            this.changeOptions();
        });

        optionsRely.forEach(x => {
            this.$watch("data." + x, function (newVal, oldVal) {
                self.reComputedOptions = true;
            })
        });
    },

    methods:{
        getAllDepart:function(cb){
            getDepart()
            .then(x=>{
                this.departList = x.Result;
                cb();
            }).catch(x=>{
                console.log(this.displayName + "-" + this.name + "数据获取异常");
                console.log(x)
            })
        },

        handleOptionsFuncScript: function () {
            switch (this.selfSetting.DepartOptions.DefaultValueType) {
                case ChoiceOptionsDefaultType.Custom:
                    break;
                case ChoiceOptionsDefaultType.DataLinkage:
                    this.filterOptionsFunc = new Function("Context", "Content", "self", this.selfSetting.DepartOptions.RelySettingString);
                    break;
                case ChoiceOptionsDefaultType.RelationForm:
                    break;
                case ChoiceOptionsDefaultType.Formula:
                    this.scriptOptionsFunc = new Function("Context", "Content", "self", this.selfSetting.DepartOptions.Script);
                    break;
                default:
                    break;
            }
        },

        changeOptions: function () {
            switch (this.selfSetting.DepartOptions.DefaultValueType) {
                case ChoiceOptionsDefaultType.Custom:
                    this.optionCustomFun();
                    break;
                case ChoiceOptionsDefaultType.DataLinkage:
                    this.optionRelyValueFun();
                    break;
                case ChoiceOptionsDefaultType.RelationForm:
                    this.optionRelationFormFun();
                    break;
                case ChoiceOptionsDefaultType.Formula:
                    this.optionFormulaExpression();
                    break;
                default:
                    break;
            }
        },
        
        optionCustomFun:function(){
            let optionsResult = this.selfSetting.DepartOptions.CustomOptions;
            this.setOptions(optionsResult);
        },

        optionRelyValueFun:function(filter){
            let context = this.buildFormContext();

            let computedfilter = this.filterOptionsFunc(context, this.data, this);
            if(filter == undefined){
                this.getRemoteOptions(computedfilter);
            }
            else{
                let filterValue = {"logic":"and","filters":[computedfilter,filter]}
                this.getRemoteOptions(filterValue);
            }
        },

        optionRelationFormFun:function(filter){
            if(filter == undefined){
                this.getRemoteOptions();
            }
            else{
                this.getRemoteOptions(filter);
            }
        },

        optionFormulaExpression:function(){
            let context = this.buildFormContext();
            let optionsResult = this.scriptOptionsFunc(context, context.Content);
            this.setOptions(optionsResult);
        },

        setOptions:function(optionsResult){
            optionsResult = optionsResult || [];
            let error =  optionsResult.length != Array.from(new Set(optionsResult)).length;
            if(error){
                console.log(this.displayName + "-" + this.name + "部门数据异常，待选项里面包含重复的");
                optionsResult = Array.from(new Set(optionsResult));
            }
            if(optionsResult.length == 0 && this.selfSetting.DepartOptions.DefaultValueType == ChoiceOptionsDefaultType.Custom){
                optionsResult = this.departList.map(x=>x.Id);
            }
            this.$options.localOptions = optionsResult;
            let departList = this.departList.filter(x=> optionsResult.includes(x.Id));
            this.options = listToTree(departList);
            this.handlerValueWhenChangeOptions();
        },

        handlerValueWhenChangeOptions:function(){
            if(this.$options.localOptions.filter(x=> x === this.data[this.name]).length == 0){
                this.data[this.name] = null;
            }
        },
    }
}